document.addEventListener('DOMContentLoaded', () => {
  const populateProductVariantLink = (variantLink) => {
    const variantHandle = variantLink.getAttribute('data-variant-handle');

    fetch(`/products/${variantHandle}?view=metafields`)
      .then(response => {
        if (!response.ok || response.redirected) {
            throw new Error('Response status: ', response.status);
        }
        return response.json();
      })
      .then(product => {

        if (product.product_variants_image != null) {
          const productImage = product.product_variants_image[0].src;
          variantLink.style.backgroundImage = `url( ${productImage + '&transform=resize=100'} )`;
          variantLink.setAttribute('data-variant-image-initialised', 'true');
        } else {
          const productImage = product.product.featured_image;
          variantLink.style.backgroundImage = `url( ${productImage + '&width=100'} )`;
          variantLink.setAttribute('data-variant-image-initialised', 'true');
        }

        let productURL = product.product_url;
        if (variantLink.hasAttribute('data-size-tag')) {
          const appliedSizeTag = variantLink.getAttribute('data-size-tag');
          for (const variant of product.product.variants) {
            if (variant.title == appliedSizeTag) {
              productURL += `?variant=${variant.id}`;
            }
          }
        }
        variantLink.href = productURL;
        variantLink.setAttribute('data-variant-link-initialised', 'true');
        variantLink.style.display = "inline-block";
      })
      .catch(error => {
          console.log('Error adding product colour variants: ', error.message, variantHandle);
      });
  }

  const productVariantLinks = document.querySelectorAll('.product-card__variants .colour-variant__link');
  if (productVariantLinks) {
    productVariantLinks.forEach((variantLink) => {
        populateProductVariantLink(variantLink);
    });
  }
})